export function getPluviometerPopUp(item: any): string {
  return `
    <iframe class="border-none w-20rem md:w-25rem h-16rem"
            src="${item.link}"
            allowfullscreen
            sandbox="allow-same-origin allow-scripts">
    </iframe>
  `;
}

export function getGatewayPopUp(item: any): string {
  let status = getGatewayStatus(item);

  return `
      <div class="w-11rem">
        <div class="w-fit h-3rem mb-3 mx-auto">
          <img src="${item?.photo}"
               alt="Antena IoT photo"
               class="w-full h-full">
        </div>

        ${status}

        <h3 class="text-md md:text-xl ci-txt--black mb-2">
          Antena ${item.name}
        </h3>

        <div class="w-full flex gap-1">
          <i class="bi bi-geo-alt-fill ci-txt--red"></i>

          <p class="w-full text-md my-0 ci-txt--black-lighten">
            ${item.location.address}
          </p>
        </div>
      </div>
  `;
}

export function getGenericSensorPopUp(item: any): string {
  return `
    <div class="w-11rem">
      <h3 class="text-md md:text-xl ci-txt--black">
        ${item.name}
      </h3>

      <p class="text-md ci-txt--black mb-2">
        ${item.location.address}
      </p>
    </div>
  `;
}

function getGatewayStatus(item: any) {
  let template = '';

  if (item?.data?.status) {
    const status = item.data.status;
    const color = status === 'ONLINE' ? 'green' : 'red';

    template = `
      <div class='w-full flex gap-2 align-items-center'>
        <div class='ci-bg--${color} border-round-3xl' style="width: 5px; height: 5px;"></div>
        <div><small class='capitalize'>${item?.data?.status}</small></div>
      </div>`;
  } else {
    template = '';
  }

  return template;
}

export function getTrashPopUp(item: any): string {
  return `
      <section class="w-14rem md:w-16rem">
        <div class="w-full h-9rem md:h-12rem bg-black-alpha-20 mb-2 border-round-md overflow-hidden shadow-1">
          <img src="${item?.photo}"
               alt="${item?.name} photo"
               class="w-full h-full">
        </div>

        <h3 class="w-full text-md md:text-xl mb-1 ci-txt--black">
          ${item.name}
        </h3>

        <div class="w-full flex gap-1">
          <i class="bi bi-geo-alt-fill ci-txt--red"></i>

          <p class="w-full text-md my-0 ci-txt--black-lighten">
            ${item.location.address}
          </p>
        </div>
      </section>
  `;
}

export function getCurrentLocationPopUp(): string {
  return `
      <div class="w-fit flex flex-column align-items-center gap-1">
        <i class="bi bi-geo-alt-fill ci-txt--cherry text-lg"></i>

        <h3 class="text-md white-space-nowrap ci-txt--black-lighten font-semibold">
          Estas aquí
        </h3>
      </div>
  `;
}

export function getGenericPanelPopUp(item: any): string {
  return `
    <div class="w-20rem h-18rem">
      <h3 class="text-xl ci-txt--black">
        ${item.name}
      </h3>

      <small class="ci-txt--black-lighten text-sm">
        ${item.location.address}
      </small>

      <iframe src="${item.link}${item.id}"
              width="100%"
              frameborder="0"
              allowfullscreen
              sandbox="allow-same-origin allow-scripts"
              class="mt-3 h-full">
      </iframe>
    </div>
  `;
}

export function getUpdateDateTime(isoString: string): string {
  const date = new Date(isoString);

  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear().toString().slice(-2);

  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');

  return `${day}/${month}/${year} ${hours}:${minutes}`;
}

export function getBaseSensorPopUp(item: any, topic: string): string {
  let component: any = getSensorHTMLBody(item, topic);
  let date: any = getUpdateDateTime(item.payload.time);

  return `
    <div class="w-17rem">
      <small class="ci-txt--grey">
        Último dato obtenido: ${date}
      </small>

      <h3 class="text-lg ci-txt--purple pb-0 pt-2">
        ${item?.payload?.deviceInfo?.tags?.Name}
      </h3>

      <article class="w-full bg-black-alpha-10 border-round-xl p-3 mt-2 flex align-items-center justify-content-center">
        ${component}
      </article>

      <section class="mt-2">
        <small class="ci-txt--grey my-0 pt-2">
          <i class="bi bi-geo-alt-fill ci-txt--red"></i> ${item?.payload?.deviceInfo?.tags?.Address}
        </small>
      </section>
    </div>
  `;
}

export function getSensorHTMLBody(item: any, topic: string) {
  let component = '';

  switch (topic) {
    case '/topic/em310':
      component = getEM310Body(item.payload.object);
      break;

    case '/topic/emudl':
      component = getEMUDLBody(item.payload.object);
      break;

    case '/topic/emco2':
      component = getEMCO2Body(item.payload.object);
      break;

    case '/topic/ws302':
      component = getWS302Body(item.payload.object);
      break;
  }

  return component;
}

function getEM310Body(data: any) {
  const distance = data?.distance != undefined ? data?.distance : '0';
  const battery = data?.battery != undefined ? data?.battery : '50';
  const status = data?.status != undefined ? data?.status : 'Lleno';
  return `
    <section class="w-full">
      <div class="w-full flex justify-content-evenly align-items-center gap-3">
        <div class="w-5rem p-2 flex flex-column justify-content-center align-items-center shadow-1 ci-bg--white border-round-xl">
          <i class="bi bi-arrows-vertical text-3xl ci-txt--cherry"></i>

          ${distance} m
          <br>
          <small>
            <strong>
              Distancia
            </strong>
          </small>
        </div>

        <div class="w-5rem p-2 flex flex-column justify-content-center align-items-center shadow-1 ci-bg--white border-round-xl">
          <i class="bi bi-battery-charging text-3xl ci-txt--green"></i>

          ${battery}%
          <br>
          <small>
            <strong>
              Batería
            </strong>
          </small>
        </div>
      </div>

      <div class="ci-marquee-container w-full flex justify-content-center align-items-center mt-3 font-bold">
        <div class="ci-marquee-item ci-marquee-item-animation-6 ci-txt--black-lighten font-bold">
            ${status}
        </div>
      </div>
    </section>
  `
}

function getEMUDLBody(data: any) {
  const distance = data?.distance != undefined ? data?.distance : '0';
  const status = data?.status != undefined ? data?.status : 'Lleno';
  return `
    <section class="w-full">
      <div class="w-full flex justify-content-evenly align-items-center gap-3">
        <div class="w-5rem p-2 flex flex-column justify-content-center align-items-center shadow-1 ci-bg--white border-round-xl">
          <i class="bi bi-arrows-vertical text-3xl ci-txt--cherry"></i>

          ${distance} m
          <br>
          <small>
            <strong>
              Distancia
            </strong>
          </small>
        </div>
      </div>

      <div class="ci-marquee-container w-full flex justify-content-center align-items-center mt-3 font-bold">
        <div class="ci-marquee-item ci-marquee-item-animation-6 ci-txt--black-lighten font-bold">
            ${status}
        </div>
      </div>
    </section>
  `
}

function getEMCO2Body(data: any) {
  return `
    <section class="w-full">
      <div class="w-full flex justify-content-evenly align-items-center gap-3 flex-wrap">
        <div class="w-5rem p-2 flex flex-column justify-content-center align-items-center shadow-1 ci-bg--white border-round-xl">
            <i class="bi bi-lungs text-3xl ci-txt--black-lighten"></i>
            ${data?.co2} ppm
            <br>

            <small>
              <strong>
                CO2
              </strong>
            </small>
        </div>

        <div class="w-5rem p-2 flex flex-column justify-content-center align-items-center shadow-1 ci-bg--white border-round-xl">
          <i class="bi bi-thermometer-sun text-3xl ci-txt--yellow"></i>
          ${data?.temperature} °C
          <br>
          <small>
            <strong>
              Temp.
            </strong>
          </small>
        </div>

        <div class="w-5rem p-2 flex flex-column justify-content-center align-items-center shadow-1 ci-bg--white border-round-xl">
          <i class="bi bi-droplet-half text-3xl ci-txt--blue"></i>
          ${data?.humidity}% RH
          <br>
          <small>
            <strong>
              Humedad
            </strong>
          </small>
        </div>

        <div class="w-5rem p-2 flex flex-column justify-content-center align-items-center shadow-1 ci-bg--white border-round-xl">
          <i class="bi bi-arrows-angle-contract text-3xl ci-txt--black-lighten"></i>
          ${data?.pressure} nPa
          <br>
          <small>
            <strong>
              Pres. Bar.
            </strong>
          </small>
        </div>
      </div>

      <div class="ci-marquee-container w-full flex justify-content-center align-items-center mt-3 font-bold">
        <div class="ci-marquee-item ci-marquee-item-animation-6 ci-txt--black-lighten">
            <i class="bi bi-lungs text-xl ci-txt--black-lighten"></i> ${data?.co2_message}
        </div>
      </div>
    </section>
  `
}

function getWS302Body(data: any) {
  const LAI = data?.LAI != undefined ? data?.LAI : 50;
  const LAeq = data?.LAeq != undefined ? data?.LAeq : 50;
  const LAImax = data?.LAImax != undefined ? data?.LAImax : 50;
  const battery = data?.battery != undefined ? data?.battery : 50;
  const status = data?.status != undefined ? data?.status : 'Normal';
  return `
    <section class="w-full">
      <div class="w-full flex justify-content-evenly align-items-center gap-3 flex-wrap">
        <div class="w-5rem p-2 flex flex-column justify-content-center align-items-center shadow-1 ci-bg--white border-round-xl">
          <i class="bi bi-volume-down text-3xl ci-txt--yellow"></i>
          ${LAI} dB
          <br>
          <small>
            <strong>
              Actual
            </strong>
          </small>
        </div>

        <div class="w-5rem p-2 flex flex-column justify-content-center align-items-center shadow-1 ci-bg--white border-round-xl">
            <i class="bi bi-soundwave text-3xl ci-txt--red-lighten"></i>
            ${LAeq} dB
            <br>

            <small>
              <strong>
                Promedio
              </strong>
            </small>
        </div>

        <div class="w-5rem p-2 flex flex-column justify-content-center align-items-center shadow-1 ci-bg--white border-round-xl">
          <i class="bi bi-volume-up text-3xl ci-txt--cherry"></i>
          ${LAImax} dB
          <br>
          <small>
            <strong>
              Máximo
            </strong>
          </small>
        </div>

        <div class="w-5rem p-2 flex flex-column justify-content-center align-items-center shadow-1 ci-bg--white border-round-xl">
          <i class="bi bi-battery-charging text-3xl ci-txt--green"></i>
          ${battery}%
          <br>
          <small>
            <strong>
              Batería
            </strong>
          </small>
        </div>
      </div>

      <div class="ci-marquee-container w-full flex justify-content-center align-items-center mt-3 font-bold">
        <div class="ci-marquee-item ci-marquee-item-animation-8 ci-txt--black-lighten">
            <i class="bi bi-ear text-xl ci-txt--yellow ml-2"></i> Nivel de sonido ${status}
        </div>
      </div>
    </section>
  `
}
